export default __webpack_public_path__ + "static/pubsec-section-1-img-993129e8033568c6d0d05759e96fa022.png";